import styled from 'styled-components';
import windowSize from '../../../constants/WindowSize';
import backgroundDark from '../../../assets/background/Login_Desktop_Dark.svg';

import variables from '../../../../_metronic/variables.scss';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
  height: 100%;

  @media(min-width: 769px){
    background-image: url(${backgroundDark});
    background-size: cover;
  }

  .btn-google {
    display: flex;
    align-items: center;
    height: 64px;
    max-width: 382px;
    width: 100%;
    background-color: #FFFFFF;
    border: 0;
    color: ${variables.colorTextLight};
    border-radius: 12px;
    padding: 5px 9px;
    margin: 0;
    font-family: 'Roboto Medium';
    box-shadow: 0px 12px 20px -15px black;
    font-size: 18px;
    gap: 12%;

    @media(max-width: 1024px){
        gap: 6vw;
        margin: 40px auto 24px;
        height: 56px !important;
        font-size: 16px;
    }
}

.btn-google img {
    width: 40px;
    margin: 0;
    background: white;
    padding: 11px;
    height: 40px;
    border-radius: 3px;
}
`;

export const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${({ width }) => width >= windowSize.SM ?
    '0 35px 40px' : 0};

  @media(min-width: 1440px){
    padding: 0px 12.79% 74px;
    justify-content: space-between;
  }
  @media(min-width: 1730px){
    justify-content:space-around;
  }

  @media(max-width: 768px){
    align-items: flex-start;
  }
`;

export const ContainerLeft = styled.div`
  max-width: 496px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 20px 0 0;

  > h1 {
    flex: 1;
    font-size: 40px;
    font-family: 'Biennale Bold';
    line-height: 48px;
    color: ${variables.detailColorLight2};
    margin: 57px 0;
  }

`;

export const Hr = styled.div`
   width: 70px;
   height: 8px;
   border-radius: 3px;
   background-color: ${variables.devariaSecondaryColor};
   margin-bottom: 40px;
`;

export const ContainerWithIcon = styled.div`
  flex: 1;
  display: flex;
  max-width: 496px;
  flex-direction: column;

  img {
    margin-left: auto;
    margin-bottom: 16px;
  }
`;

export const ContainerRight = styled.div`
  display: flex;
  padding: ${({ width }) => width >= windowSize.SM ?
    `56px 55px` : `0 24px`};
  flex-direction: column;
  align-items: flex-start;
  max-width: 496px;
  border: ${({ width }) => width >= windowSize.SM ?
    `1px solid ${variables.colorTextDark}`
    : 0};
  border-radius: 18px;

  @media(min-width: 576px) {
    background: ${variables.backgroundTertiary};
  }

  @media(max-height: 787px){
    padding: 38px 55px;
    /* height: 575px; */
  }

  @media(max-width: 768px){
    align-items: center;
    height: 100%;
    padding: ${({ width }) => width >= windowSize.SM ? `56px 55px` : `0 24px`};
  }

  h1 {
    flex: 1;
    font-size: 28px;
    font-family: 'Biennale Bold';
    line-height: 40px;
    color: ${props => props.theme.colors.primary};
    margin: 40px 0;

    @media (max-width: 768px){
      width: 100%;
      max-width: 384px;
    }
  }
`;

export const ContainerInputs = styled.div`
  width: 100%;
  flex-direction: column;
  max-width: 384px;

  > h1 {
    color: ${props => props.theme.colors.primary};
    margin-bottom: 20px;
    margin-top: 20px;
  }

  small {
      color: ${props => props.theme.colors.primary};
  }

  .btn-login {
    margin-top: 32px;
  }
`;

export const ContainerForgotPassword = styled.div`
  width: 100%;
  padding: 24px 0 32px;
  /* padding: 24px 0 0; */
  max-width: 384px;
  text-align: center;

  @media(max-width: 768px){
    padding: 24px 0;
  }

  a {
    text-decoration: underline;
    color: ${props => props.theme.colors.primary};
    font-size: 16px;
    font-family: 'Biennale';

    @media(max-width: 768px){
      font-size: 14px;
    }
  }
`;

export const ContainerRegister = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  max-width: 384px;
  font-size: 18px;
  font-family: 'Biennale';
  gap: 5px;

  span {
    color: ${props => props.theme.colors.text};
  }

  a {
    margin-left: 5px;
    color: ${variables.primaryColor3};
    text-decoration: underline;
    font-family: 'Biennale Bold';
  }

  @media(max-width: 768px){
    flex-direction: column;
    font-size: 16px;
    line-height: 24px;
    gap: 0;
    margin-bottom: 40px;
  }
`;

export const ContainerLoginGoogle = styled.div`
  width: 100%;
  max-width: ${props => props.maxWidth ? props.maxWidth : '384px'};

  > div {
    flex: 1;
    margin: 32px 0;

    @media(max-width: 768px){ margin: 24px 0; }

    hr {
      flex: 1;
      margin: 0 10px;
      background-color: ${props => props.theme.colors.text};
    }
  }

  span {
    color: ${props => props.theme.colors.text};
    font-size: 16px;
    font-family: 'Biennale Regular';

    @media(max-width: 768px){
      font-size: 14px;
    }
  }
`;
